<template>
    <div
        class="modal"
        style="background-color: rgba(0, 0, 0, 0.4)"
        v-show="modalOpen"
    >
        <div
            class="modal-content"
            style="width: 80%; height: 95vh; max-width: none"
        >
            <div class="modal-header">
                <div class="flex align-center justify-end">
                    <button class="btn btn-close" @click="closeModal">
                        Zatvori
                    </button>
                </div>
            </div>
            <div class="modal-body" style="flex: 1">
                <embed
                    :src="href"
                    :style="{
                        width: '100%',
                        height: '100%'
                    }"
                    type="text/html"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            modalOpen: false,
            href: null,
        };
    },

    created() {
        document.addEventListener("click", (e) => {
            console.log(e.path);

            if (
                e.path[0].classList.contains("pdf") ||
                e.path[1].classList.contains("pdf")
            ) {
                e.preventDefault();

                let pdfA = null;

                if (e.path[0].classList.contains("pdf")) {
                    pdfA = e.path[0];
                }

                if (e.path[1].classList.contains("pdf")) {
                    pdfA = e.path[1];
                }

                if (pdfA) {
                    this.href = pdfA.href;
                    this.modalOpen = true;
                }
            }
        });
    },

    methods: {
        closeModal() {
            this.modalOpen = false;
            this.href = null;
        },
    },
};
</script>
